import { Menu } from "antd";
import { useMemo, useState } from "react";
import { GoMail } from "react-icons/go";
import { LiaWhatsapp } from "react-icons/lia";
import { PiChatsCircle, PiPhoneCall, PiRobot } from "react-icons/pi";
import useStore from "zustand/store";
import SideModalV2 from "../SideModalV2";
import CustomerService from "./components/CustomerService";
import ForCall from "./components/ForCall";
import ForEmail from "./components/ForEmail";
import ForWhatsapp from "./components/ForWhatsapp";

const ContactButton: React.FC<{ textColor?: string }> = ({ textColor }) => {
    const { user } = useStore()
    const [state, setState] = useState({
        openModal: false,
        modalMode: "",
    });

    const toggleModal = (val?: string) => {
        setState(prev => ({ ...prev, openModal: !prev.openModal, modalMode: val || "" }));
    };

    // Memoize the overlay menu to prevent re-renders
    const menuOverlay = useMemo(() => (
        <Menu className="!bg-[#280202] !flex !flex-col !items-end">
            {[
                { text: "Customer Service", icon: <PiChatsCircle className="mr-2 text-xl" /> },
                { text: "Email Address", icon: <GoMail className="mr-2 text-[16px]" /> },
                { text: "Whatsapp", icon: <LiaWhatsapp className="mr-2 text-xl" /> },
                { text: "Chat Bot", icon: <PiRobot className="mr-2 text-xl" /> },
                { text: "Call", icon: <PiPhoneCall className="mr-2 text-xl" /> },
            ].map((obj, idx) => (
                <Menu.Item key={idx} onClick={() => toggleModal(obj.text)}
                    className={`${textColor ? textColor : "!text-[#fff]"}`}>
                    <div className="flex items-center py-2">
                        <div>{obj.icon}</div> {obj.text}
                    </div>
                </Menu.Item>
            ))}
        </Menu>
    ), [textColor]); // Memoizes the menu based on `textColor`

    if (user?.id) return null

    return (
        <>
            <SideModalV2 width="75vw" open={state.openModal} toggle={toggleModal} header={"Contact Support"}>
                {state.modalMode === "Customer Service" && <CustomerService toggle={toggleModal} />}
                {state.modalMode === "Email Address" && <ForEmail toggle={toggleModal} />}
                {state.modalMode === "Whatsapp" && <ForWhatsapp toggle={toggleModal} />}
                {state.modalMode === "Call" && <ForCall toggle={toggleModal} />}
                {state.modalMode === "Chat Bot" && <ForCall toggle={toggleModal} />}
            </SideModalV2>

            {/* <Dropdown placement="top" overlay={menuOverlay} trigger={["click"]}>
                <button className="z-10 flex items-center bg-[#E67E7E] text-[14px] px-4 py-2 rounded-[22px] text-[#fff] fixed bottom-[20px] right-[20px]">
                    <PiChatsCircle className="mr-2 text-xl" />
                    Contact Support
                </button>
            </Dropdown> */}
        </>
    );
};

export default ContactButton;
